import Modal from '@/shared/components/Modal';
import React from 'react';
import styled, { css } from '@emotion/native';
import { sand } from '@/shared/styles/colors';
import ModalCloseButton from '@/shared/components/ModalCloseButton';
import { BaseText, H3 } from '@/shared/components/StyledText';
import PriceFilters from './PriceFilters';
import Spacer from '@/shared/components/Spacer';
import { TouchableOpacity } from 'react-native';
import useExploreStore from '@/stores/useExploreStore';
import ExpertiseFilters from './ExpertiseFilters';
import GenderFilters from './GenderFilters';
import AgePreferenceFilter from './AgePreferenceFilter';
import StylingPreferencesFilter from './StylingPreferencesFilter';
import SessionTypeFilter from './SessionTypeFilter';
import InPersonAvailabilityFilter from './InPersonAvailabilityFilter';
import CityFilter from './CityFilter';
import BackToTopButton from '@/shared/components/BackToTopButton';
import { useScrollToTop } from '@/shared/hooks/useScrollToTop';
import ModalButton from '@/components/shared/ModalButton';
import ModalWrapper from '@/shared/styles/components/ModalWrapper';
import { useEventConfiguration } from '@/shared/hooks/useEventConfiguration';
import { Portal } from 'react-native-paper';

interface FiltersProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
}

const FiltersModal = ({ isVisible, setIsVisible }: FiltersProps) => {
  const { setFilters, filters } = useExploreStore();
  const scrollToTop = useScrollToTop();
  const { inPersonEventSessions } = useEventConfiguration();

  const handleClearAll = () => {
    setFilters({
      priceTier: [],
      expertise: [],
      stylingPreferences: [],
      age: [],
      gender: null,
      sessionType: null,
      availableInPerson: null,
      cities: [],
    });
  };

  return (
    <Modal isVisible={isVisible} setIsVisible={setIsVisible}>
      <Portal.Host>
        <ModalWrapper isScrollable includeBottomPadding style={containerStyles}>
          <ModalCloseButton onPress={() => setIsVisible(false)} />
          <InnerContainer>
            <Spacer height={74} />
            <Title>filter stylists</Title>
            <TouchableOpacity
              onPress={handleClearAll}
              style={{ marginBottom: 28 }}
            >
              <ClearText>Clear All</ClearText>
            </TouchableOpacity>
            {inPersonEventSessions && <SessionTypeFilter />}
            <InPersonAvailabilityFilter />
            {filters.availableInPerson && <CityFilter />}
            <PriceFilters />
            <ExpertiseFilters />
            <GenderFilters />
            <AgePreferenceFilter />
            <StylingPreferencesFilter />
            <Spacer height={24} />
            <BackToTopButton scrollToTop={scrollToTop} />
            <Spacer height={32} />
          </InnerContainer>
        </ModalWrapper>
        <ModalButton
          onPress={() => setIsVisible(false)}
          text="Apply Filters"
          disabled={false}
        />
      </Portal.Host>
    </Modal>
  );
};

const containerStyles = css({
  backgroundColor: sand,
  width: '100%',
});

const Title = styled(H3)({
  textTransform: 'uppercase',
  textAlign: 'center',
  marginBottom: 28,
});

const ClearText = styled(BaseText)({
  textAlign: 'center',
  textDecorationLine: 'underline',
  fontWeight: 'bold',
});

const InnerContainer = styled.View({
  paddingHorizontal: 34,
});

export default FiltersModal;
